'use client';
import { useEffect } from 'react';

import { fetchVehicle } from '@core/Services/Vehicle/FetchVehicle';

interface ClientVehicleCheckProps {
  vehicleId: string;
}

export const ClientVehicleCheck = ({ vehicleId }: ClientVehicleCheckProps) => {
  useEffect(() => {
    let isMounted = true;
    (async () => {
      const vehicle = await fetchVehicle(vehicleId, 'uk');
      if (!vehicle && isMounted) {
        const cookieName = 'favourites';
        const cookieValueString = String(
          document.cookie
            .split('; ')
            .find(row => row.startsWith(`${cookieName}=`))
            ?.split('=')[1] || '[]',
        );
        const cookieValue = decodeURIComponent(cookieValueString);
        const favs = (() => {
          try {
            return JSON.parse(cookieValue);
          } catch {
            return [];
          }
        })();
        const updatedVehicleIds = favs.filter(
          (vid: string | number) => String(vid) !== String(vehicleId),
        );
        document.cookie = `${cookieName}=${JSON.stringify(updatedVehicleIds)}; path=/`;
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [vehicleId]);
  return null;
};
